// ABOUTME: Shared timezone validity check reused by DeliveryWindowForm and OperationalHoursForm.
// ABOUTME: Only validates a value the user actually changed this session — untouched/inherited values are never rejected.

import {useMemo} from 'react'

export const useTimeZoneValidation = (
  timeZone: string,
  isTimeZoneDirty: boolean,
  invalidMessage: string,
): string | undefined => {
  const validTimeZones = useMemo(() => new Set([...Intl.supportedValuesOf('timeZone'), 'UTC']), [])

  return useMemo(() => {
    if (!isTimeZoneDirty) return undefined
    const trimmed = timeZone.trim()
    if (!trimmed) return undefined
    return validTimeZones.has(trimmed) ? undefined : invalidMessage
  }, [timeZone, isTimeZoneDirty, validTimeZones, invalidMessage])
}
